@if (d) {
    <qp-table-data
        [nullValues]=false
        [data]="
            [
                { k: AppStrings.Survey_Running, v: d.surveyrunning | yesno }
            ]
        "

        (selected)="select($event)"
    >
    </qp-table-data>
    <!-- <mat-icon class="tab-icon">{{ Icons.link }}</mat-icon> -->
}